module.exports = __webpack_public_path__ + "img/stepsbottomarrow.589ad68c.svg";